let countries = ["Albania", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Belgium",
    "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia & Herzegovina", "Botswana", "Brazil", "Brunei Darussalam", "Bulgaria", "Burundi", "Cambodia", "Canada",
    "Cape Verde", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Cyprus", "Czech Republic",
    "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "Gabon",
    "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guadeloupe", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Holy See (Vatican)", "Honduras", "Hungary", "Iceland",
    "India", "Indonesia", "Ireland", "Israel", "Italy", "Ivory Coast (Cote d'Ivoire)", "Japan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Republic of (South Korea)",
    "Kuwait", "Kyrgyz Republic (Kyrgyzstan)", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia",
    "Maldives", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco",
    "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Papua New Guinea",
    "Paraguay", "Peru", "Poland", "Portugal", "Qatar", "Romania", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
    "Sao Tome and Principe", "Saudi Arabia", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia",
    "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Tajikistan", "Thailand", "Timor Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia",
    "Turkmenistan", "Tuvalu", "Ukraine", "United Kingdom", "Uruguay", "United States", "Uzbekistan", "Vanuatu", "Zambia",
    "Zimbabwe"]


function buildCountryList() {
    let countriesDiv = document.getElementById("countries-desktop");
    let count = -1;
    let html;

    for (let i = 0; i < Math.ceil(countries.length / 3); i++) {
        html = "<div class='row mt-0 country-row'>";
        for (let j = 0; j < 3; j++) {
            count++;
            if (count < countries.length) {
                html += "<div class='column d-flex justify-content-center'>" +
                    "<strong class='font-size-20 p-3'>" + countries[count] + "</strong>" +
                    "</div>";
            } else {
                html += "<div class='column'></div>";
            }
        }

        html += "</div>";
        countriesDiv.innerHTML += html;
    }
}

function buildCountryListMobile() {
    let countriesDiv = document.getElementById("countries-mobile");
    let html = "";

    for (let i = 0; i < countries.length; i++) {
        if (countries[i] !== undefined) {
            html += "<div class='column country-column d-flex justify-content-center'>" +
                "<strong class='font-size-20 p-3'>" + countries[i] + "</strong>" +
                "</div>"
        }
    }
    countriesDiv.innerHTML += html;
}

buildCountryList();
buildCountryListMobile();